import React from 'react';
import { IProps } from './types';

const Head: React.FC<IProps> = (props) => (
  <div className="member-only__head">
    <div className="template-container">
      <div className="template-content">
        <div className="member-only__period">
          <span>{`活動期間 : ${props.activityDate}`}</span>
        </div>
        <div className="member-only__main">
          <div className="member-only__title">{props.title}</div>
          <div className="member-only__pc-logos">
            {props.leftImgUrl && (
              <div className="member-only__logo-img">
                <img src={props.leftImgUrl} alt="promotion-info-logo-1st" />
              </div>
            )}
            {props.leftImgUrl && props.rightImgUrl && (
              <div className="member-only__logo-and" />
            )}
            {props.rightImgUrl && (
              <div className="member-only__logo-img">
                <img src={props.rightImgUrl} alt="promotion-info-logo-2nd" />
              </div>
            )}
          </div>
        </div>
        <p className="member-only__desc">{props.subTitle}</p>
        <div className="member-only__mobile-logos">
          {props.leftImgUrl && (
            <div className="member-only__logo-img">
              <img src={props.leftImgUrl} alt="promotion-info-logo-1st" />
            </div>
          )}
          {props.leftImgUrl && props.rightImgUrl && (
            <div className="member-only__logo-and" />
          )}
          {props.rightImgUrl && (
            <div className="member-only__logo-img">
              <img src={props.rightImgUrl} alt="promotion-info-logo-2nd" />
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default Head;
